<mat-card>
    <mat-toolbar color="primary">Consultas Gerenciais</mat-toolbar>
    <mat-card-content>
        <div *ngIf="consultasGerenciais.length === 0" class="indisponivel">
            <span>Ainda não existem consultas personalizadas disponíveis!</span>
        </div>
        <div class="itens-flex" *ngIf="!consultaSelecionada">
            <button mat-fab extended *ngFor="let consulta of consultasGerenciais" 
                color="primary" 
                class="button-acao" 
                (click)="executarAcaoConsulta(consulta)">
                <mat-icon>description</mat-icon>
                <span class="texto-botao">{{consulta.tituloConsulta}}</span>
            </button>
        </div>
        <div class="scrollBar" *ngIf="consultaSelecionada">
            <div class="titulo-consulta">
                <button mat-icon-button color="primary" (click)="voltarParaLista()" *ngIf="consultaSelecionada">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <h3>{{consultaSelecionada.tituloConsulta}}</h3>
            </div>
            <span>{{consultaSelecionada.descricao}}</span>
            <table *ngIf="!isPesquisando && respostaConsulta && respostaConsulta.length > 0" class="tabela tabela-responsive">
                <thead>
                    <tr>
                        <th *ngFor="let consulta of respostaConsulta[0]">
                            {{consulta.descricao}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let consulta of respostaConsulta">
                        <td *ngFor="let campo of consulta">
                            {{ campo.valor }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="alinhar-itens">
			<mat-spinner class="spinner-align" mode="indeterminate" *ngIf="isPesquisando">
			</mat-spinner>
		</div>
    </mat-card-content>
</mat-card>